import { APP_NAME, SheetExportTypes } from '../xlsxExport.constants';
import { CustomColumnStyle } from '../constants/styles';

import metadataBuilder from './metadataBuilder';
import frozenViewsBuilder from './styleBuilders/frozenViewsBuilder';

const calculateNumberOfColumns = (data: unknown[][]) => {
  let widestRowLength = 1;

  data.forEach(row => {
    if (row.length > widestRowLength) {
      widestRowLength = row.length;
    }
  });

  return widestRowLength;
};

const buildColumnStyles = (columnCount: number) => Array(columnCount).fill(CustomColumnStyle);

export type CustomBuilderSheet = {
  type: SheetExportTypes.CUSTOM,
  name: string,
  data: unknown[][],
  options: {
    addTimestamp?: boolean,
  }
}

type CustomBuilderOptions = {
  description?: string,
  periodName?: string
}


const customBuilder = (sheet: CustomBuilderSheet, options: CustomBuilderOptions = {}) => {
  const { description, periodName } = options;
  const { options: sheetOptions } = sheet;
  const { addTimestamp } = sheetOptions;

  const sheetMetadata = metadataBuilder({
    appName: APP_NAME,
    sheetTitle: sheet.name,
    sheetDescription: description,
    periodName,
    addTimestamp,
  });

  const grid = [
    ...sheetMetadata,
    ...sheet.data,
  ];

  const metadata = {
    sheetName: sheet.name,
    views: frozenViewsBuilder({
      rows: sheetMetadata.length,
      columns: 0,
    }),
    columnStyles: buildColumnStyles(calculateNumberOfColumns(sheet.data)),
    rowStyles: [],
  };

  return {
    metadata,
    grid,
  };
};

export default customBuilder;
